export const DATA_HOOKS = {
  root: 'about-page',
  createdBy: 'groupInfo-createdBy',
};

export const GROUP_ACTIVITY_INFO_CARD = 'group-activity-info-card';
